// The illustration language: soft geometric forms in identity colors on deep
// ink, ambient motion via SVG animation (docs/DESIGN.md). Inline components so
// they theme with tokens and honor reduced motion via CSS.

import "./illustrations.css";

/** Floating notes: empty universes and first drafts. */
export function FloatingNotes() {
  return (
    <svg viewBox="0 0 160 120" fill="none" className="bd-ill">
      <circle cx="80" cy="64" r="44" className="bd-ill__halo" />
      <g className="bd-ill__float">
        <circle cx="56" cy="52" r="7" fill="var(--accent)" />
        <rect x="61" y="20" width="2.5" height="32" rx="1.25" fill="var(--accent)" />
      </g>
      <g className="bd-ill__float bd-ill__float--late">
        <circle cx="96" cy="72" r="6" fill="var(--text-3)" />
        <rect x="100" y="44" width="2.5" height="28" rx="1.25" fill="var(--text-3)" />
      </g>
      <g className="bd-ill__float bd-ill__float--later">
        <circle cx="118" cy="46" r="4.5" fill="var(--text-4)" />
        <rect x="121" y="26" width="2" height="20" rx="1" fill="var(--text-4)" />
      </g>
    </svg>
  );
}

/** Breathing waveform: sound library, takes, quiet audio surfaces. */
export function BreathingWave() {
  const bars = [14, 26, 40, 30, 48, 36, 52, 34, 44, 24, 32, 16];
  return (
    <svg viewBox="0 0 160 120" fill="none" className="bd-ill">
      {bars.map((h, i) => (
        <rect
          key={i}
          className="bd-ill__bar"
          style={{ animationDelay: `${i * 0.12}s` }}
          x={22 + i * 10}
          y={60 - h / 2}
          width="5"
          height={h}
          rx="2.5"
          fill={h >= 44 ? "var(--accent)" : "var(--text-3)"}
          opacity={0.4 + (h / 52) * 0.55}
        />
      ))}
    </svg>
  );
}

/** Cassette: empty search results. */
export function Cassette() {
  return (
    <svg viewBox="0 0 160 120" fill="none" className="bd-ill">
      <rect x="28" y="34" width="104" height="56" rx="8" fill="var(--glass-strong)" stroke="var(--line-strong)" />
      <rect x="44" y="46" width="72" height="18" rx="4" fill="var(--ink-0)" />
      <g className="bd-ill__spin">
        <circle cx="58" cy="55" r="6.5" stroke="var(--text-3)" strokeWidth="2" />
        <rect x="57" y="49.5" width="2" height="4" fill="var(--text-3)" />
      </g>
      <g className="bd-ill__spin bd-ill__spin--slow">
        <circle cx="102" cy="55" r="6.5" stroke="var(--text-3)" strokeWidth="2" />
        <rect x="101" y="49.5" width="2" height="4" fill="var(--text-3)" />
      </g>
      <rect x="52" y="72" width="56" height="10" rx="3" fill="var(--glass)" />
    </svg>
  );
}

/** Oscilloscope: loading and generation. */
export function Oscilloscope() {
  return (
    <svg viewBox="0 0 160 120" fill="none" className="bd-ill">
      <rect x="24" y="28" width="112" height="64" rx="10" fill="var(--ink-0)" stroke="var(--line-strong)" />
      <path
        className="bd-ill__trace"
        d="M32 60 Q44 30 56 60 T80 60 T104 60 T128 60"
        stroke="var(--accent)"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Constellation: the universe graph, connections between ideas. */
export function Constellation() {
  return (
    <svg viewBox="0 0 160 120" fill="none" className="bd-ill">
      <path d="M40 80 L70 44 L104 62 L124 36" stroke="var(--line-strong)" strokeWidth="1.5" />
      <path d="M70 44 L96 92" stroke="var(--line-strong)" strokeWidth="1.5" />
      <circle cx="40" cy="80" r="6" fill="var(--text-3)" className="bd-ill__pulse" />
      <circle cx="70" cy="44" r="8" fill="var(--accent)" className="bd-ill__pulse bd-ill__float--late" />
      <circle cx="104" cy="62" r="5" fill="var(--text-3)" className="bd-ill__pulse bd-ill__float--later" />
      <circle cx="124" cy="36" r="4" fill="var(--text-4)" />
      <circle cx="96" cy="92" r="5" fill="var(--text-4)" />
    </svg>
  );
}

/** Offline: a small island of safety. */
export function Island() {
  return (
    <svg viewBox="0 0 160 120" fill="none" className="bd-ill">
      <ellipse cx="80" cy="88" rx="46" ry="10" fill="var(--glass-strong)" />
      <path d="M62 88 Q66 58 80 52 Q94 58 98 88 Z" fill="var(--ink-3)" stroke="var(--line-strong)" />
      <circle cx="80" cy="44" r="8" fill="var(--accent)" className="bd-ill__pulse" />
    </svg>
  );
}
